export enum CommunicationEnum {
    Call = 0,
    Email = 1
}